import { render, staticRenderFns } from "./course-in.vue?vue&type=template&id=5dfcf545&lang=pug&"
import script from "./course-in.vue?vue&type=script&lang=js&"
export * from "./course-in.vue?vue&type=script&lang=js&"
import style0 from "./course-in.vue?vue&type=style&index=0&id=5dfcf545&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports